angular.module('bmsApp.settings')
	.controller('CleaningServicesCtrl', [
		'$scope',
		'SMCleaningServiceSvc',
		'$log',
		'$state',
		'notify',
		'$q',
		'$filter',
		'AuthService',
		'TaxHelperSvc',
		'SMCleaningServiceCategorySvc',
		'LicenseOptionsSvc',
		'InstanceSvc',
		function ($scope,
				  SMCleaningServiceSvc,
				  $log,
				  $state,
				  notify,
				  $q,
				  $filter,
				  AuthService,
				  TaxHelperSvc,
				  SMCleaningServiceCategorySvc,
				  LicenseOptionsSvc,
				  InstanceSvc) {

			function init() {
				self.ecomEnabled = InstanceSvc.instance.ecomEnabled();
				// self.ecomLive = InstanceSvc.instance.getFranchise().ecom_live;
				var promises = [
					SMCleaningServiceSvc.index()
						.then(function (response) {
							self.cleaningServices = response.data.cleaning_service_collection;
						}),
					TaxHelperSvc.getVatRate()
						.then(function (vatRate) {
							self.vatRate = vatRate;
						}),
					LicenseOptionsSvc.license()
						.then((response) => {
							self.licenses = response.data.options;
							// Remove bulky attributes that we don't want to submit
							angular.forEach(self.licenses, (license) => {
								delete license.postcodes;
							});
						}),
				];
				$q.all(promises)
					.then(function () {
						angular.forEach(self.cleaningServices, function (service) {
							// pre-populate the vat and gross on each service as this is not currently stored
							onServiceNetChanged(service);
							angular.forEach(self.licenses, (licence) => {
								let existing = $filter('filter')(service.child_services, (item) => {
									return parseInt(item.license_id) === parseInt(licence.id);
								});
								if (!existing.length) {
									service.child_services.push({
										license: licence,
										category: angular.copy(service.category),
										description: service.description,
										duration_in_mins: service.duration_in_mins,
										gross: service.gross,
										net: service.net,
										vat: service.vat,
										is_enabled: false,
										is_online: false,
										label: service.label,
										parent_id: null,
										value: service.value,
										is_rug_service: service.is_rug_service,
										requires_material_test: service.requires_material_test,
										technicians_required: service.technicians_required,
									});
								}
							});

						});
						self.loading = false;
						// see comment in submit method for why this is here
						self.processing = false;
					});

				getCategories();
			}

			function setEditable(setting) {
				setting.editing = true;
			}

			function cancelEditing(setting) {
				setting.editing = false;
			}

			function save(setting) {
				setting.editing = false;
				init();
			}

			function remove(setting, index) {
				if (setting.newlyAdded) {
					self.cleaningServices.splice(index, 1);
				}
				else {
					setting.deleted = true;
				}
			}

			function reinstate(setting) {
				setting.deleted = false;
			}

			function addNew() {
				let newService = {
					editing: true,
					newlyAdded: true,
					child_services: [],
				};

				self.cleaningServices.push(newService);

				angular.forEach(self.licenses, (licence) => {
					newService.child_services.push({
						license: licence,
						is_enabled: false,
						is_online: false,
					});

				});
			}

			function submit() {
				self.processing = true;

				let errorServicesWithoutCategory = [];
				// Make sure each cleaning service has a category which is_online
				angular.forEach(self.cleaningServices, (service) => {
					if (service.is_online && service.category === null) {
						let string = 'Base service: ' + service.label + ' requires a category';
						errorServicesWithoutCategory.push(string);
					}

					if (service.child_services && service.child_services.length) {
						angular.forEach(service.child_services, (childService) => {
							if (childService.is_online && childService.category === null) {
								let string = 'Child service: ' + service.label + ' requires a category';
								errorServicesWithoutCategory.push(string);
							}
						});
					}
				});

				if (errorServicesWithoutCategory.length) {
					notify({
						message: errorServicesWithoutCategory.join(', '),
						classes: 'error'
					});
					self.processing = false;
					return;
				}

				SMCleaningServiceSvc.save({cleaningServices: self.cleaningServices})
					.then(function (response) {
						notify({
							message: 'Cleaning services updated'
						});
						self.category.label = '';
						// Ideally init() would be a promise so that processing can be set to false once the data has been reloaded, but for now processing is re-set to false inside init(), innit
						init();
					});
			}

			function saveCategory() {
				SMCleaningServiceCategorySvc.save({category: self.category})
					.then(function (response) {
						notify({
							message: 'Category saved'
						});
						getCategories();
						self.category = {};
					});
			}

			function getCategories() {
				SMCleaningServiceCategorySvc.options()
					.then(function (response) {
						self.categories = response.data.cleaning_service_category_options;
					});
			}

			function editCategory(category) {
				self.category = category;
			}

			function removeCategory(category) {
				SMCleaningServiceCategorySvc.remove(category)
					.then(function (response) {
						notify({
							message: 'Category removed'
						});
						getCategories();
					}, function (errors) {
						self.errors = errors;
					});
			}

			function onServiceNetChanged(service) {
				service.vat = TaxHelperSvc.vatFromNet(service.value);
				service.gross = TaxHelperSvc.grossFromNet(service.value);
			}

			function onServiceGrossChanged(service) {
				service.value = TaxHelperSvc.netFromGross(service.gross);
				service.vat = TaxHelperSvc.vatFromGross(service.gross);
			}

			function showOnlinePricing() {
				SMCleaningServiceSvc.showOnlineCleaningPricingModal();
			}

			function onChildServiceEnabledChanged(parentService, childService) {
				if (childService.is_enabled) {
					angular.extend(childService, {
						description: parentService.description,
						duration_in_mins: parentService.duration_in_mins,
						gross: parentService.gross,
						net: parentService.net,
						vat: parentService.vat,
						label: parentService.label,
						value: parentService.value,
						is_rug_service: parentService.is_rug_service,
						requires_material_test: parentService.requires_material_test,
						technicians_required: parentService.technicians_required,
					});
				}
			}

			var self = $scope.CleaningServicesCtrl = {
				loading: true,
				processing: false,
				cleaningServices: [],
				category: {},
				methods: {
					init: init,
					submit: submit,
					setEditable: setEditable,
					cancelEditing: cancelEditing,
					remove: remove,
					addNew: addNew,
					reinstate: reinstate,
					saveCategory: saveCategory,
					editCategory: editCategory,
					removeCategory: removeCategory,
					onServiceNetChanged: onServiceNetChanged,
					onServiceGrossChanged: onServiceGrossChanged,
					showOnlinePricing: showOnlinePricing,
					onChildServiceEnabledChanged: onChildServiceEnabledChanged,
				}
			};

		}
	]);
